import { combineReducers } from "redux";
import serviceReducer from "./serviceReducers";

export default combineReducers({
  services: serviceReducer,
});
